(ns ycweb.app.website.registry.modals
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.crop :as awm.crop]
   [ycweb.app.website.myaccount.profile.profile :as profile]
   [ycweb.app.website.registry.common :as arm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [util.string :as str]
   [ycweb.util.urlstate :as urlstate]))

;; Registry Pop-Up Body
(rum/defc welcome-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Nicely done. What to do next?"
       {:type :h2
        :size :medium})
     [:p
      {:class (u/bem :yc-paragraph [:medium-large])}
      [:b
       {:class (u/bem :text-status [:success])}
       "Your Registry is all set up and ready to use."]
      " To get the most out of your Registry, we recommend the following four steps:"]
     (headings/heading "1. Customise it"
       {:type :h3
        :size :tiny})
     [:p.yc-paragraph
      "Upload a photo of yourselves, choose a cover design, write a personalised message to your guests, update your personal information."]
     (headings/heading "2. Add products"
       {:type :h3
        :size :tiny})
     [:p.yc-paragraph
      "Browse our range and handpick products to add to your Registry, or auto-populate it with a Starter Collection."]
     (headings/heading "3. Tell your guests"
       {:type :h3
        :size :tiny})
     [:p.yc-paragraph
      "Telling guests about your registry can be a little delicate. We did our homework and canvassed our Yuppiechef Registry users as to the best way to go about it. By far the most popular method is to include a little note with the invitation. Our favourite wording is, "
      [:i
       (str "\"If you would like to spoil us with a gift we have a gift registry with Yuppiechef. Our registry is at www.yuppiechef.com/yc" (:client-order/id config) "\"")]
      "."]
     (headings/heading "4. Manage it"
       {:type :h3
        :size :tiny})
     [:ul.yc-list
      [:li
       "Mark items you especially want as your favourites to help guests choose."]
      [:li
       "Opt in to receive emails notifications of your live purchases using the Thank You Manager."]
      [:li
       "Nominate 3 guests to receive a special 10% discount off your Registry items."]]
     (buttons/button-web "Got it, I'm ready."
       {:on-click
        (fn [_]
          (grid/dispatch-action app-atom :web.registry/edit.tutorial-viewed {})
          (grid/close-modal app-atom))
        :style :secondary
        :size :standard})]))

(defmethod grid/modal-config :web.registry/welcome-modal [_ _ _]
  {:body welcome-modal-body
   :modal-type :variable
   :cancel-key :web.registry/edit.tutorial-viewed})

;; Find registry modal
(rum/defc find-registry-modal-body < rum/reactive [app-atom config-atom _]
  (let [search-atom (rum/cursor-in app-atom [:registry :search])]
    [:<>
     (headings/heading
       "Find a wedding registry"
       {:type :h2
        :size :small})
     [:div
      [:div.form-field
       {:id "registry-search"}
       (forms/split-input-field
         ["First name:" "e.g. Jane"
          (rum/cursor-in search-atom [:first-name])
          {:type :user :id :firstname :name :firstname :hint "Try searching either of the couple's names" :auto-focus true}]
         ["Last name:" "e.g. Smith"
          (rum/cursor-in search-atom [:last-name])
          {:type :user :id :lastname :name :lastname}
          {}])]

      (buttons/button-web
        "Search"
        {:value "Search"
         :style :primary
         :size  :default
         :on-click
         #(grid/dispatch-action app-atom :web.registry/search @search-atom)})]]))

(defmethod grid/modal-config :web.registry/find-registry-modal [_ _ _]
  {:body find-registry-modal-body
   :modal-type :alert})

;; Create registry modal
(rum/defc create-registry-modal-body < rum/reactive [app-atom _ _]
  [:<>
   (headings/heading
     "Do you want to:"
     {:type :h2
      :size :small})
   [:div.u-margin-bottom-10
    (buttons/button-web "Create a Registry"
      (merge
        (urlstate/href-props app-atom "registry" "create")
        {:type  :button
         :style :primary
         :full true
         :flat-style :raised}))]
   (buttons/button-web "Manage Existing Registry"
     (merge
       (urlstate/href-props app-atom "myaccount" "registry")
       {:type :button
        :style :secondary
        :full true
        :flat-style :raised}))])

(defmethod grid/modal-config :web.registry/create-registry-modal [_ _ _]
  {:body create-registry-modal-body
   :modal-type :variable
   :max-width 320})

;; Cover Option
(rum/defc cover-option < rum/reactive [app-atom background-id _]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom [:registry])]
    [:article
     {:class (u/bem :flex-grid-block [:ml-1-3 :t-1-2])}
     [:div.flex-grid-content
      [:a
       {:on-click
        #(grid/dispatch-action app-atom :web.registry/edit.edit-background
           {:background/id background-id
            :registry/uuid (:ent/uuid registry)})
        :class (u/bem :visual-option [(when (= background-id (:registry/background-id registry)) :active)])}
       [:figure.visual-option__content
        [:img.simple-image
         {:src
          (u/cloudinary
            (str "pages/registry/wallpapers/registry-wallpaper-" background-id ".png")
            {:f "auto"
             :h 120
             :w 233
             :c "thumb"})
          :alt ""
          :class (u/bem :yc-simple-image [:full])}]
        [:span.visual-option__icon
         [:i {:class (u/bem :icon [:block :default :is-light :check])}]]
        [:span
         {:class (str "visual-option__colour-bar  u-bg-" (arm.common/colour-look-up background-id))}]]]]]))

(def background-options (range 16 28))

;; Change Cover Modal
(rum/defc change-cover-modal-body < rum/reactive [app-atom _ _]
  [:div.yc-section
   [:p
    {:class (u/bem :yc-paragraph [:flush])}
    "Personalise your cover image, choose below:"]
   [:div.flex-grid-group
    (map (partial cover-option app-atom) background-options)]])

(defmethod grid/modal-config :web.registry/change-cover-modal [_ _ _]
  {:body change-cover-modal-body
   :modal-type :variable})

;; Close Registry Modal
(rum/defc close-registry-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Registry Checkout"
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      "Remember, only click 'Close my Registry' after your celebration, when you are ready to review all your gift purchases, checkout & arrange delivery."]
     [:div
      {:class (u/bem :flex-grid-group [:flush-force :align-left])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Oops, don't close it yet. Go Back"
          {:style :primary
           :on-click
           #(do
              (.preventDefault %)
              (grid/close-modal app-atom))
           :size :default})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Got it! Continue and Close"
          (merge
            (urlstate/href-props app-atom "registry" "close" {:uuid (:registry/uuid config)})
            {:type :button
             :style :secondary
             :size :default}))]]]]))

(defmethod grid/modal-config :web.registry/close-registry-modal [_ _ _]
  {:body close-registry-modal-body
   :modal-type :variable})

(rum/defc guest-add-item-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Item has been added"
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      [:b
       {:class (u/bem :text-status [:success])}
       "The item you selected has been added to your Cart."]
      " Please note you have one hour to make payment before we'll have to release it back into the wild for someone else to buy."]
     [:p
      {:class (u/bem :yc-paragraph [:flush :large])}
      [:b "Your order total: "] [:span.js-popup-orderTotal (:order-total config)]]
     [:div.u-max-width-480
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:s-1-2])}
        [:div.flex-grid-content
         (buttons/button-web "Continue Shopping"
           {:on-click
            #(do
               (.preventDefault %)
               (grid/close-modal app-atom))
            :style :secondary
            :size :default
            :full true})]]
       [:div
        {:class (u/bem :flex-grid-block [:s-1-2])}
        [:div.flex-grid-content
         (let [new-cart-enabled (cmn/curact app-atom [:features :new-cart])]
           (buttons/button-web "Proceed to Checkout"
             (merge
               (if new-cart-enabled
                 (urlstate/href-props app-atom "order")
                 {:href "/order.htm?action=ShowCart"})
               {:style :primary
                :size :default
                :full true})))]]]]
     [:p
      {:class (u/bem :yc-paragraph [:small])}
      "You will not be able to add anything else to your Cart that is not part of this Registry."]]))

(defmethod grid/modal-config :web.registry/guest-add-item-modal [_ _ _]
  {:body guest-add-item-modal-body
   :modal-type :variable})

(rum/defc product-preview-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading [[:b (:brand config)] " " (:name-ex-brand config)]
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      {:dangerouslySetInnerHTML
       {:__html
        (:teaser config)}}]]))

(defmethod grid/modal-config :web.registry/product-preview-modal [_ _ _]
  {:body product-preview-modal-body
   :modal-type :variable})

(defmethod grid/action :web.registry/product-preview-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/product-preview-modal
    {:config config}))

(rum/defc guest-add-item-error-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Item cannot be added"
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      [:b
       {:class (u/bem :text-status [:error])}
       "We could not add this product to your Cart,"]
      " because you already have items from another Registry or shopping spree."]
     [:p.yc-paragraph
      [:b
       "To avoid us getting confused about who to send the gifts to, please:"]]
     [:ol.yc-list
      [:li
       [:a
        (merge
          (urlstate/href-props app-atom "order")
          {:class (u/bem :text-link [:muted])})
        "Proceed to Checkout"]
       " with the items in your current Cart"]
      [:li "Place your order and pay for those items"]
      [:li "Then come back and add items from this Registry"]]]))

(defmethod grid/modal-config :web.registry/guest-add-item-error-modal [_ _ _]
  {:body guest-add-item-error-body
   :modal-type :variable})

;; Choose Registry Modal
(rum/defc choose-registry-modal-body < rum/reactive [app-atom config-atom _]
  (let [{:keys [registry-action]} (rum/react (cmn/process-cursor app-atom))
        {:keys [registries selected-registry] :as config} (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Choose a Registry"
       {:type :h2
        :size :small})
     [:div.form-field
      [:label.form-label
       {:for "registries"}
       "Please choose a registry:"]
      [:div.select-wrapper
       (forms/select-raw
         (rum/cursor-in config-atom [:config :selected-registry])
         (concat
           [{:value nil :text "Please Select"}]
           (map
             (fn [r]
               {:text (str (when (:registry/event-type r) (str (:registry/event-type r) ": ")) (:registry/title r))
                :value (:client-order/id r)}) (vals registries)))
         {:type :number})]]
     [:div.form-control
      (buttons/button-web "Add to Registry"
        {:type :button
         :on-click
         #(grid/dispatch-action app-atom :web.registry/edit.selected
            {:registry (get registries selected-registry)
             :registry-action registry-action})
         :style :primary
         :size :default})]]))

(defmethod grid/modal-config :web.registry/choose-registry-modal [_ _ _]
  {:body choose-registry-modal-body
   :modal-type :variable})

(rum/defc no-registry-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Add to Registry"
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      "You are not currently logged in with a registry."]
     [:p.yc-paragraph
      "Head over to the "
      [:a.text-link
       (urlstate/href-props app-atom "registry")
       "Wedding Registry"]
      " page to login to your existing registry or to set up a new one quickly and easily."]
     [:div
      {:class
       (u/bem
         :flex-grid-group
         [:row :align-left :valign-middle :flush])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid :m-0-1])}
       (buttons/button-web "View wedding registry"
         (merge
           (urlstate/href-props app-atom "registry")
           {:style :primary
            :size :default
            :class :button-group__item}))]
      [:div
       {:class (u/bem :flex-grid-block [:fluid :m-0-1])}
       (buttons/button-web "Create a registry"
         (merge
           (urlstate/href-props app-atom "registry" "create")
           {:style :secondary
            :size :default
            :class :button-group__item}))]]]))

(defmethod grid/modal-config :web.registry/no-registry-modal [_ _ _]
  {:body no-registry-modal-body
   :modal-type :alert})

;; Discontinued Modal
(rum/defc item-discontinued-modal < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Discontinued Item"
       {:type :h2
        :size :small
        :class :text-status--error})
     [:p.yc-paragraph
      "This item has unfortunately been discontinued since it was bought for you by your guest, which means it is no longer available."]
     [:p
      "Because we are flexible and allow you to chop and change your gift selection before delivery, it means we cannot reserve the item for you even when it is bought by a guest."]
     [:p.yc-paragraph [:b "You have 2 options:"]]
     [:ol.yc-list
      [:li
       "You can swap the item now for something else in our range. "
       [:b "Note:"]
       " if your colour or size choice is unavailable then you may be able to simply change the variation."]
      [:li
       "You can opt for a Yuppiechef voucher to the value of the item, that you can use at a later stage."]]
     [:p.yc-paragraph
      {:class (u/bem :text-status [:important])}
      [:b "Please note:"]
      " that you must remove or swap any discontinued items from your Registry otherwise you will not be able to close it."]
     [:p.yc-paragraph
      "Thank you for understanding. Please don't hesitate to contact "
      [:a.text-link
       (urlstate/href-props app-atom "help")
       "Customer Service"]
      " to discuss your options further."]]))

(defmethod grid/modal-config :web.registry/item-discontinued-modal [_ _ _]
  {:body item-discontinued-modal
   :modal-type :variable})

;; Out of Stock Modal
(rum/defc purchase-list-out-of-stock-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)]
    [:<>
     (headings/heading "Temporarily Unavailable Item"
       {:type :h2
        :size :small
        :class :text-status--error})
     [:p.yc-paragraph
      "Because we are flexible and allow you to chop and change your gift selection before delivery, it means we cannot reserve an item for you even when it is bought by a guest."]
     [:p.yc-paragraph [:b "You have 3 options:"]]
     [:ol.yc-list
      [:li "You're welcome to wait for new stock to come in."]
      [:li
       "You can swap the item now for something else in our range. "
       [:b "Note:"]
       " if your colour or size choice is unavailable then you may be able to simply change the variation."]
      [:li
       "You can opt for a Yuppiechef voucher to the value of the item, that you can use at a later stage."]]
     [:p.yc-paragraph
      "Thank you for understanding. Please don't hesitate to contact "
      [:a.text-link
       (urlstate/href-props app-atom "help")
       "Customer Service"]
      " to discuss your options further."]]))

(defmethod grid/modal-config :web.registry/purchase-list-out-of-stock-modal [_ _ _]
  {:body purchase-list-out-of-stock-modal-body
   :modal-type :variable})

(defmethod grid/action :web.registry/item-discontinued-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/item-discontinued-modal
    {:config {:title "Item Discontinued"}}))

(rum/defc collection-added-modal-body < rum/reactive [app-atom config-atom _]
  (let [{:keys [registry title] :as config} (cmn/curact config-atom :config)]
    [:<>
     (headings/heading title {:type :h2})
     [:div.button-group.u-block-center
      [:div.u-margin-bottom-10
       (buttons/button-web "Continue browsing"
         {:style :primary
          :size :default
          :full true
          :on-click
          #(do
             (.preventDefault %)
             (grid/close-modal app-atom))})]
      (buttons/button-web "View registry"
        (merge
          (urlstate/href-props app-atom "registry" "edit" {:uuid (:registry/uuid config)})
          {:style :secondary
           :size :default
           :full true}))]]))

(defmethod grid/modal-config :web.registry/collection-added-modal [_ _ _]
  {:body collection-added-modal-body
   :modal-type :alert
   :max-width 320})

;; Delete Registry Modal
(rum/defc delete-registry-modal-body < rum/reactive [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom :registry)]
    [:<>
     (headings/heading "Are you sure you want to delete your registry?" {:type :h2 :size :default})
     [:p.yc-paragraph
      "Once this is deleted you won't be able to access your registry from your account view."]
     [:div
      {:class (u/bem :flex-grid-group [:flush-force :align-left])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "I want to keep it"
          {:style :secondary
           :size :default
           :on-click #(grid/close-modal app-atom)})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Yes, delete it"
          {:style :negative
           :size :default
           :on-click
           #(grid/dispatch-action app-atom :web.registry/close.delete {:uuid (:ent/uuid registry)})})]]]]))

(defmethod grid/modal-config :web.registry/delete-registry-modal [_ _ _]
  {:body delete-registry-modal-body
   :modal-type :variable})

;; Help Setup Modal
(rum/defc help-setup-modal-body < rum/reactive [app-atom config-atom a]
  (let [process-atom (cmn/process-cursor app-atom)
        create-details (cmn/curact process-atom [:registry :create-details])
        {:create-details/keys [order-id]} create-details]
    [:<>
     (headings/heading "We're here to help"
       {:type :h2
        :size :small})
     [:p.yc-paragraph
      "Give us a call on "
      [:a.text-link
       {:href "tel:+278617024969"}
       "+27 (0)861 702 4969"]
      " or "
      [:a.text-link
       {:href "mailto:hello@yuppiechef.com"}
       "send us an email"]
      "."
      (when order-id
        (str " Your reference is YC" order-id "."))
      " We also have "
      [:a.text-link
       (urlstate/href-props app-atom "help" "category" {:id 7 :name "Registries"})
       "helpful articles and FAQs"]
      " if you need them."]
     (buttons/button-web "View Help Articles"
       (merge
         (urlstate/href-props app-atom "help" "category" {:id "7" :name "Registries"})
         {:style :primary
          :size :small}))]))

(defmethod grid/modal-config :web.registry/help-setup-modal [_ _ _]
  {:body help-setup-modal-body
   :modal-type :variable})

;; Checkout Voucher Only Modal
(rum/defc voucher-only-modal-body < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)
        voucher-amount (str "R" (u/currency-format (:amount config) 2))]
    [:<>
     (headings/heading "Receive a Yuppiechef voucher instead of guest purchased gifts."
       {:type :h2
        :size :small})
     [:p (str "You will receive a Yuppiechef voucher worth " voucher-amount ".")]]))

(rum/defc voucher-only-modal-footer < rum/reactive [app-atom config-atom _]
  (let [config (cmn/curact config-atom :config)
        registry-uuid (:uuid config)]
    (grid/pos-call-to-action
      {:left-text "Cancel"
       :left-fn #(grid/close-modal app-atom)
       :left-no-icon true
       :right-text "Checkout"
       :right-fn #(grid/dispatch-action app-atom :web.registry/checkout {:uuid registry-uuid})
       :right-style :call-to-action
       :right-no-icon true})))

(defmethod grid/modal-config :web.registry/voucher-only-modal [_ _ _]
  {:body voucher-only-modal-body
   :footer voucher-only-modal-footer
   :modal-type :variable})

(rum/defcs upload-photo-modal-body < rum/reactive
  (cmn/local
    {:orientation 1
     :crop {:p1 [10 10] :p2 [220 220] :imgsize [240 240] :targetsize [240 240]}} ::nodes)
  [local-atom app-atom config-atom _]
  (let [cropped (cmn/curact (::nodes local-atom) [:cropped])]
    [:<>
     (headings/heading "Upload an image"
       {:type :h2
        :size :small})
     [:form.form.u-max-width-480
      {:method "post" :encType "multipart/form-data" :action "registry.htm?action=photoUpload"}
      [:div.form-field
       [:label.form-label "Select an image from your computer:"]
       [:div.yc-text-input-wrapper
        [:input.yc-text-input
         {:type "file"
          :name "myfile"
          :accept (str/join "," (u/get-allowed-types :image))
          :ref (fn [dom-or-nil] (swap! (::nodes local-atom) assoc :file dom-or-nil))
          :on-change #(profile/load-image (::nodes local-atom) app-atom)}]]
       [:div.form-hint-wrapper
        [:span.form-hint [:b "Note: "] "Image must be 4MB max and either JPG, PNG or GIF"]]]

      (when (cmn/curact (::nodes local-atom) [:encoded])
        [:<>
         [:div
          {:class (u/bem :flex-grid-group [:align-left :flush])}
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2 :flush])}
           [:div.flex-grid-content
            [:div.form-field
             (awm.crop/crop-pic (::nodes local-atom))]]]
          (when cropped
            [:div
             {:class (u/bem :flex-grid-block [:m-1-2 :flush])}
             [:div.flex-grid-content
              [:div.form-field.u-max-width-180
               {:style {:margin "auto"}}
               [:label.form-label
                "Preview:"]
               [:img.avatar
                {:src cropped
                 :class (u/bem :yc-simple-image [:full :border :shadow])}]]]])]
         [:div.form-field.button-group
          (buttons/button-web "Rotate 90"
            {:style :secondary :size :small
             :on-click (fn [e] (.preventDefault e) (profile/rotate-image (::nodes local-atom)))
             :class "u-margin-right-10"})
          (buttons/button-web "Crop and preview"
            {:style :primary :size :small
             :on-click
             (fn [e]
               (.preventDefault e)
               (awm.crop/write-cropped (::nodes local-atom)
                 (fn [b64]
                   (swap! (::nodes local-atom) assoc :cropped b64))))})]

         (when (cmn/curact (::nodes local-atom) [:cropped])
           [(buttons/button-web "Upload"
              {:style :primary :size :default
               :on-click
               (fn [e]
                 (.preventDefault e)
                 (grid/dispatch-action app-atom :web.registry/edit.edit-photo
                   {:data (:cropped @(::nodes local-atom))}))
               :class "u-margin-top-20  u-margin-bottom-10"})
            [:br]])])

      [:small "By uploading an image you certify that you have the right to use it."]]]))

(defmethod grid/modal-config :web.registry/upload-photo-modal [_ _ _]
  {:body upload-photo-modal-body
   :modal-type :alert})

(rum/defc registry-feedback-modal-body < rum/reactive [_ config-atom _]
  (let [message (:msg @config-atom)]
    [:<>
     (headings/heading "Can't delete registry" {:type :h2 :size :default})
     [:p.yc-paragraph
      [:b message]]]))

(defmethod grid/modal-config :web.registry/registry-feedback-modal [_ _ _]
  {:body registry-feedback-modal-body
   :modal-type :variable})
